module.exports = __webpack_public_path__ + "6844c1e61f33b8715dbe4488beca7d21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_1.jpg
// module id = 1691
// module chunks = 5